import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-179" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-180" data-mp="o4713081h8ii">
        <SectionHeading id="summary-title" data-id="element-181" data-mp="j7yfb3zc6h2d">Tutto ciò che è <span className="text-sky-400" data-id="element-182" data-mp="j53v9dk8iy9h">incluso:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-slate-800 bg-slate-900 sm:grid-cols-2" data-id="element-183" data-mp="1guf8bx11e8ib">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-800 p-4 sm:odd:border-r" data-id="element-184" data-mp="16wrc12ns8sy1">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sky-400" data-id="element-185" data-mp="12vpb8he7w8ty">
                <CheckIcon className="h-3.5 w-3.5 text-slate-950" aria-hidden="true" data-id="element-186" data-mp="3rn8kwm2fq4ew" />
              </span>
              <b className="text-sm text-white" data-id="element-187" data-mp="3nkbxmi1y9k4m">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}